/* eslint-env jest */
import { isFreeSitting, showsAppointmentCoupon } from './appointmentCheckout';

// Elementary retake bookings (/c/checkout?app=true, no senior=true) had no
// coupon box, and a 100%-off one would have asked for a shipping address.
// These are the two rules the checkout reads for an appointment.
const sitting = (attrs = {}) => ({ appointmentTime: '2026-11-14T09:05:00Z', ...attrs });
const cartOf = (attrs = {}) => ({
  apiTotal: 0, couponId: '7', orderPackages: [sitting()], ...attrs,
});

describe('showsAppointmentCoupon', () => {
  it('shows on an elementary appointment checkout', () => {
    expect(showsAppointmentCoupon({ app: 'true', cart: cartOf() })).toBe(true);
  });

  it('shows on a senior appointment checkout', () => {
    expect(showsAppointmentCoupon({ app: 'true', senior: 'true', cart: cartOf() })).toBe(true);
  });

  it('waits for the cart to load', () => {
    expect(showsAppointmentCoupon({ app: 'true', cart: undefined })).toBe(false);
  });

  it('is not shown on the ordinary order checkout (it has its own review step)', () => {
    expect(showsAppointmentCoupon({ app: undefined, cart: cartOf() })).toBe(false);
  });
});

describe('isFreeSitting', () => {
  it('books a 100%-off elementary sitting directly', () => {
    expect(isFreeSitting({ app: 'true', cart: cartOf() })).toBe(true);
  });

  it('books a $0 elementary sitting with no coupon directly', () => {
    expect(isFreeSitting({ app: 'true', cart: cartOf({ couponId: null }) })).toBe(true);
  });

  it('is not free while anything is still owed', () => {
    expect(isFreeSitting({ app: 'true', cart: cartOf({ apiTotal: 10 }) })).toBe(false);
  });

  it('keeps the shipping step when the cart holds anything that is not a sitting', () => {
    const cart = cartOf({ orderPackages: [sitting(), sitting({ appointmentTime: null })] });
    expect(isFreeSitting({ app: 'true', cart })).toBe(false);
  });

  it('keeps the shipping step for an empty cart', () => {
    expect(isFreeSitting({ app: 'true', cart: cartOf({ orderPackages: [] }) })).toBe(false);
  });

  it('is never true off the appointment checkout', () => {
    expect(isFreeSitting({ app: undefined, cart: cartOf() })).toBe(false);
  });

  it('is false until the cart loads', () => {
    expect(isFreeSitting({ app: 'true', cart: undefined })).toBe(false);
  });

  // Seniors are unchanged: any $0 senior cart books directly, as before.
  it('keeps the senior rule as it was', () => {
    const cart = cartOf({ orderPackages: undefined });
    expect(isFreeSitting({ app: 'true', senior: 'true', cart })).toBe(true);
    expect(isFreeSitting({ app: 'true', senior: 'true', cart: cartOf({ apiTotal: 5 }) })).toBe(false);
  });
});
